// src/pages/Admin/GruposAdminPage.jsx
import GruposAdmin from "../../../components/GruposAdmin/index";

export default function GruposOfertas() {
    return <GruposAdmin tipo="ofertas" titulo="Controle de Acessos - Grupos de Ofertas" />;
}

export function GruposShopee() {
    return <GruposAdmin tipo="shopee" titulo="Controle de Acessos - Grupos da Shopee" />;
}

export function GruposPet() {
    return <GruposAdmin tipo="pet" titulo="Controle de Acessos - Grupos Pet" />;
}

export function GruposGames() {
    return <GruposAdmin tipo="games" titulo="Controle de Acessos - Grupos Games" />;
}

export function GruposFerramentas() {
    return <GruposAdmin tipo="ferramentas" titulo="Controle de Acessos - Grupos Ferramentas" />;
}

export function GruposTvs() {
    return <GruposAdmin tipo="tvs" titulo="Controle de Acessos - Grupos TVS" />;
}

export function GruposPerfumes() {
    return <GruposAdmin tipo="perfumes" titulo="Controle de Acessos - Grupos Perfumes" />;
}
